import React from 'react'
import Combine from '../../components/Combine/Combine'
import StudentProfile from './StudentProfile'

const Student = () => {
  return (
   <Combine>
    <StudentProfile/>
   </Combine>
  )
}

export default Student
